"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOLUTION_TEXT = void 0;

var ResolutionText =
/** @class */
function () {
  function ResolutionText() {}

  ResolutionText.prototype.checkPresentInSameNamespace = function (kind) {
    return "Check if the " + kind + " is present in the same namespace.";
  };

  ResolutionText.prototype.checkInDifferentNamespace = function (kind, ownerKind) {
    return "Check if the " + kind + " is present in a different namespace.\n            Kubevious Search can be a very handy tool to find " + kind + "s across namespaces.\n            You cannot mount a " + kind + " from a different namespaces.\n            In that case you would need to create a " + kind + " in namespace where the " + ownerKind + " resides.";
  };

  ResolutionText.prototype.typoNameReference = function (kind, typoLocation) {
    return "Did you make a typo in the " + typoLocation + "?\n            Kubevious Search uses fuzzy logic to return results and can help with finding the correct " + kind + ".";
  };

  ResolutionText.prototype.populateEnvVarsData = function (kind) {
    return "Populate data in the " + kind + " so it is mapped as environment variables.";
  };

  ResolutionText.prototype.deleteEnvVarsSource = function (kind) {
    return "Delete the empty " + kind + " if indeed no environment variables are supposed to be sourced from that " + kind + ".";
  };

  return ResolutionText;
}();

exports.RESOLUTION_TEXT = new ResolutionText();